











































































































































































import { v4 as uuidv4 } from 'uuid';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import SearchAndOrder from '@core/interfaces/bpc-search-and-order';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import DatePicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';

@Component({
  name: 'bulk-renewal-contract-actions-modal',
  components: {
    'bpc-entity-select': EntitySelect,
    'bpc-date-picker': DatePicker,
  },
})
export default class BulkRenewalContractActionsModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: String, default: 'bulk-renewal-contract' }) readonly modalId: string;
  @Prop({ type: String, default: 'contract' }) readonly entityName: string;
  @Prop({ type: String, default: null }) readonly selectedAction: string;
  @Prop({ type: Object, default: null }) readonly filters: object;
  @Prop({ type: Object, default: null }) readonly searchAndOrder: SearchAndOrder;
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly selectedEntities: string[];
  @Prop({ type: Number, default: 0 }) readonly totalEntities: number;
  @Prop({ type: Boolean, default: false }) readonly checkedAll: boolean;
  @Prop({
    type: Array,
    default() {
      return [['code', 'contact'], ['name']];
    },
  })
  readonly dataToShow: [string[]];
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly extraData: object[];

  // Data
  public contractActionEventsError: object[] = [];
  public contractActionEventsSuccess: object[] = [];
  public contractActionRequestSent: boolean = false;
  public isProcessing: boolean = false;
  public reportPerPage: number = 10;
  public reportCurrentPage: number = 1;
  public processAll: boolean = false;
  public selectedPeriode = null;
  public startDate: string = null;
  public endDate: string = null;

  // Lifecycle
  mounted() {
    if (this.showModal) {
      this.openModal();
    }
  }

  // Computed
  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }
  get title() {
    return this.$t(`global.modals.bulk-contract-${this.selectedAction}.title`);
  }
  get body() {
    return this.$t(`global.modals.bulk-contract-${this.selectedAction}.body`);
  }
  get reportRows() {
    return this.contractActionEventsError.length;
  }
  get reportCurrentList() {
    const start = this.reportCurrentPage * this.reportPerPage - this.reportPerPage;
    const end = start + this.reportPerPage;
    return this.contractActionEventsError.slice(start, end);
  }

  // Methods
  openModal(): void {
    this.resetModal();
    this.$bvModal.show(this.modalId);
  }
  closeModal(): void {
    this.resetModal();
    this.$bvModal.hide(this.modalId);
  }
  resetModal(): void {
    this.contractActionEventsError = [];
    this.contractActionEventsSuccess = [];
    this.contractActionRequestSent = false;
    this.isProcessing = false;
    this.processAll = false;
    this.selectedPeriode = null;
    this.startDate = null;
    this.endDate = null;
  }
  onConfirmContractAction(): void {
    const basePath = this.$bpcApiRouteHelper.getEntityPath(this.entityName);
    const sessionCode = this.getSessionCode();
    this.listenToWebsocketRenewalContractChannel(sessionCode);
    this.contractActionRequestSent = true;

    this.$bpcApi
      .post(basePath + `/bulk-${this.selectedAction}`, {
        entities: this.selectedEntities,
        filters: this.filters,
        search_and_order: this.searchAndOrder ? this.searchAndOrder : {},
        process_all: this.processAll,
        session_code: sessionCode,
        start_date: this.startDate,
        end_date: this.endDate,
        period_id: this.selectedPeriode ? this.selectedPeriode.id : null,
        ...this.extraData,
      })
      .subscribe(
        res => {
          this.$emit('request-sent');
        },
        error => {
          this.$emit('error-sending-request');
          this.$bpcEcho.leaveRenewalContractChannel(sessionCode);
          this.resetModal();
        },
      );
  }
  getSessionCode(): string {
    return `${uuidv4()}`;
  }
  listenToWebsocketRenewalContractChannel(sessionCode): void {
    this.isProcessing = true;
    this.$bpcEcho
      .listenRenewalContractChannel(sessionCode)
      .listen('.BPC\\Contracts\\Events\\RenewalContractEntitiesProcessed', data => {
        this.$bpcMessage.showInfoMessage({
          text: `global.actions.bulk_renewal_contract.${this.selectedAction}.entities_processed`,
        });
        this.isProcessing = false;
        this.$emit('processed');
        this.$bpcEcho.leaveRenewalContractChannel(sessionCode);
      })
      .listen('.BPC\\Contracts\\Events\\RenewalContractEntityProcessed', data => {
        this.contractActionEventsSuccess.push(data);
      })
      .listen('.BPC\\Contracts\\Events\\RenewalContractErrorProcessingEntity', data => {
        this.contractActionEventsError.push(data);
      });
  }
  onCloseModal(): void {
    this.$emit('on-close-modal');
  }

  // Watchers
  @Watch('showModal')
  onChangeShowModal(val) {
    if (val) {
      this.openModal();
    } else {
      this.closeModal();
    }
  }

  @Watch('selectedPeriode')
  onSelectedPeriodIdChange(val) {
    if (val) {
      this.startDate = val.start_date;
      this.endDate = val.end_date;
    }
  }
}
